module.exports = __webpack_public_path__ + "static/media/5_17.296904f4.png";